<template>
	<!-- MAIN MODAL -->
	<b-modal :id="domID" :title="computedModalLabel" @hidden="hidden" cancel-disabled ok-disabled scrollable size="xl" no-enforce-focus>

		<!-- <div>
			<strong>Is user menu: {{ isUserMenu }}</strong>
			<code>args: {{ args }}</code>
		</div> -->

		<b-form @submit="onSubmit">
			<b-row>
				<b-col id="menuFormHolder" md="4">

					<b-card id="imgHolder" bg-variant="light">
						<storage-img-uploader v-model="form.imagen" label="Portada del menu" />
					</b-card>

					<!-- NOMBRE -->
					<b-form-group label="* Nombre del plan:" label-for="form-nombre">
						<b-form-input id="form-nombre" v-model="form.nombre" required />
					</b-form-group>
					<!-- NOMBRE -->

					<!-- PORCION -->
					<b-form-group label="Miembros:" label-for="form-porcion">
						<b-form-input id="form-porcion" type="number" step="1" v-model="form.miembros_" readonly />
					</b-form-group>
					<!-- PORCION -->

					<!-- CERTIFICACION -->
					<b-card class="bg-light" header="Certificación del menú" v-if="!isUserMenu">
						<b-input-group>
							<b-input-group-prepend is-text>
								<b-form-checkbox v-model="form.certificacion_estatus" unchecked-value="Sin revisión"
									value="Certificado" switch class="mr-n2">
									<span class="sr-only">Disponibilidad de certificación</span>
								</b-form-checkbox>
							</b-input-group-prepend>
							<b-form-datepicker v-model="form.certificacion_fecha" aria-label="Fecha de certificación"
								:disabled="form.certificacion_estatus == 'Sin revisión'" />
						</b-input-group>
						<b-input-group prepend="Responsable" class="mt-4"
							v-if="form.certificacion_estatus == 'Certificado'">
							<b-form-input v-model="form.certificacion_responsable"
								aria-label="Responsable de certificación"></b-form-input>
						</b-input-group>
					</b-card>
					<!-- CERTIFICACION -->
				</b-col>

				<b-col id="dataholder" md="8">

					<div style="display: none">
						<input :id="idHolder">
					</div>

					<!-- EDICIÓN DE MENÚ -->
					<b-card id="daysHolder" class="mt-2" no-body>
						<b-tabs id="daysTab" pills card>
							<b-tab v-for="(day, $dayIndex) in days" :key="$dayIndex" :title="day">
								<b-card v-for="(meal, $mealIndex) in comidasIndex" :key="meal">
									<div slot="footer">
										<b-row align-h="between" align-v="center">
											<b-col>
												{{ meal }}
											</b-col>
											<b-col cols="2">
												<b-button :id="('btn-' + ($dayIndex + 1) + '-' + ($mealIndex + 1))"
													size="sm" block variant="primary"
													@click="ask4NewItem('btn-' + ($dayIndex + 1) + '-' + ($mealIndex + 1), ($dayIndex + 1), ($mealIndex + 1))">
													<i class="fa fa-plus"></i>
												</b-button>
											</b-col>
										</b-row>
									</div>
									<template v-if="true">
										<b-jumbotron class="mb-0" v-if="!planesTree[$dayIndex + '-' + $mealIndex].length">
											<template #lead>
												No hay platillos registrados para éste horario.
											</template>
										</b-jumbotron>
										<div class="planReceta mb-0 mt-0"
											v-for="(planReceta, $index) in planesTree[$dayIndex + '-' + $mealIndex]"
											:key="$index">
											<b-row class="mt-2 mb-2" align-v="center" align-h="between">
												<b-col>
													{{ planReceta.receta.nombre }}
												</b-col>
												<b-col cols="2">
													<b-button-group size="xs">
														<b-button v-if="isUserMenu" @click="variantioModule(planReceta.id_receta_fk)"><i class="fa fa-cog"></i></b-button>
														<b-button @click="tryRemovePlanReceta(planReceta.dia, planReceta.tipo, planReceta.id_receta_fk)" variant="danger"><i class="fa fa-trash"></i></b-button>
													</b-button-group>
												</b-col>
											</b-row>
										</div>
									</template>
								</b-card>
							</b-tab>
						</b-tabs>
					</b-card>

					<!-- CLASIFICADORES -->
					<menu-categorizacion v-if="!isUserMenu" v-model="form.asides.plan_has_planclasificadores" />

				</b-col>
			</b-row>
		</b-form>

		<template v-slot:modal-footer="{ cancel }">
			<b-button size="sm" variant="outline-danger" @click="tryToDelete(form.id_pk)"
				v-if="!isProcessing && !!form.id_pk">
				<i class="fa fa-trash"></i> {{ labelsCfg.btnDelete }}
			</b-button>

			<b-button size="sm" @click="cancel()" v-if="!isProcessing">{{ labelsCfg.btnCancel }}</b-button>

			<!-- Button with custom close trigger value -->
			<b-button size="sm" :variant="variant" @click="store()" v-if="!isProcessing">
				{{ labelsCfg.btnApply }}
			</b-button>

			<!-- Button with custom close trigger value -->
			<b-button size="sm" :variant="variant" disabled v-if="isProcessing">
				<span key="spin">
					<i class="fa fa-cog fa-spin"></i>
				</span>
				{{ labelsCfg.btnIsProcessing }}
			</b-button>
		</template>

		<recetas-modificadores ref="RecetasModificadores" v-model="form.asides.planrecetasvariaciones" :planes-id="form.id_pk" :debug="debug"/>

		<div class="debug" v-if="debug">
			<h1>form.asides.planrecetasvariaciones</h1>
			<code><pre>{{ form.asides.planrecetasvariaciones }}</pre></code>
		</div>

	</b-modal>
	<!-- MAIN MODAL -->
</template>

<script>
import axios from "axios";
import _ from "lodash";
import swal from "sweetalert";
import imgInputAutoload from "@/views/elements/img-input-autoload.vue";
import mobiscroll from "@mobiscroll/javascript";
import md5 from "js-md5";
import moment from "moment";
import { mapGetters } from "vuex";
import MenuCategorizacion from './MenuCategorizacion.vue';
import RecetasModificadores from "./RecetasModificadores.vue";

let days = [
	'Lunes',
	'Martes',
	'Miércoles',
	'Jueves',
	'Viernes',
	'Sábado',
	'Domingo',
];
let comidasIndex = ['Desayuno', 'Comida', 'Cena'];

let dataSource = "nutricion/planhandler"; // Para crear, actualizar y borrar

let planArchetype = {

	// SYS
	id_pk: null,
	id_usuario_fk: null,
	id_ultimo_usuario_fk: null,
	imagen: null,

	ultima_actualizacion: null,
	ultima_fecha: null,

	// FORM
	nombre: null,
	miembros_: null,

	// CERTIFICACION
	certificacion_estatus: 'Sin revisión',
	certificacion_fecha: null,
	certificacion_responsable: null,

	// ASIDES
	asides: {
		plan_has_planclasificadores: [], // PARA CATEGORIZACIÓN
		planreceta: [],	 // PLANRECETA
		recetas: [],		// RECETAS
		planmiembros: [],   // PLAN MIEMBROS
		usuarios: [],		// LOS USUARIOS INCLUÍDOS
		planrecetasvariaciones: []
	}
};

let labelsCfg = {
	emptyHeader: "Lista vacía",
	emptyLead: "",
	searchPlaceholder: "Buscador...",
	newLabel: "Nuevo menú",
	editLabel: "Actualización de menú",
	btnDelete: "Eliminar",
	btnCancel: "Cancelar",
	btnApply: "Aplicar",
	btnIsProcessing: "Procesando...",
};

export default {
	name: "MenuMainModal",
	props: {
		debug: {
            type: Boolean,
            default: false
        },

		args: {
			type: Object,
			default: () => { return {} }
		}
	},

	components: {
		MenuCategorizacion,
		imgInputAutoload,
		RecetasModificadores
	},

	computed: {
		...mapGetters(["authGetUser"]),
		isUserMenu(){
			let r = false;
			try {
				if(!_.isNil(this.args.usuarioIdPk) )
					r = true;
			} catch(e){
				console.error(e)
			}
			return r;
		},
		computedModalLabel() {
			return (this.form.id_pk) ? this.labelsCfg.editLabel : this.labelsCfg.newLabel
		},
		computedURI() {
			return axios.defaults.baseURL + '/nutricion/recetasmobi/';
		},
		dataMD5() {
			return md5(JSON.stringify(this.form));
		},
		planesTree() {
			let tree = {};
			_.forEach(days, (item, $dayIndex) => {
				_.forEach(comidasIndex, (comItem, $mealIndex) => {
					let mealDayArray = []
					_.forEach(_.filter(_.clone(this.form.asides.planreceta), (item) => {
						return ((parseInt(item.dia) == ($dayIndex + 1)) && (parseInt(item.tipo) == ($mealIndex + 1)))
					}), selectedItem => {
						selectedItem.receta = _.find(this.form.asides.recetas, { id_pk: selectedItem.id_receta_fk })
						mealDayArray.push(selectedItem)
					})
					tree[$dayIndex + '-' + $mealIndex] = mealDayArray
				})
			})
			return tree
		}
	},

	data: () => {
		return {
			comidasIndex,
			idHolder: null,
			days,
			domID: null,
			isLoading: false,
			isProcessing: false,
			variant: "primary",
			dataSource,
			labelsCfg: _.cloneDeep(labelsCfg),
			originalData: _.cloneDeep(planArchetype),
			mobi: null,
			form: _.cloneDeep(planArchetype)
		};
	},

	methods: {

		variantioModule(planRecetaIdFk){
			this.$refs.RecetasModificadores.reviewReceta(planRecetaIdFk)
		},

		// AGREGA O RUEMVE UN ID DE CLASIFICADOR VALOR
		toggleClasificdorValor(id_pk) {
			let indexOfPos = this.form.asides.valor.indexOf(id_pk);
			if (indexOfPos == -1) this.form.asides.valor.push(id_pk);
			else this.form.asides.valor.splice(indexOfPos, 1);
		},

		// PREPARA LO QUE TENGAS QUE PREPARAR PARA SUBIR AL SERVIDIOR,
		// COMO AGREGAR VALIDACIONES, DATOS O PROPIEDADES DINÁMICAS, ETC.
		// DEVULEVE FALSO PARA DETENER EL ENVÍO
		getDataForSubmit() {
			let data = _.cloneDeep(this.form);

			_.forEach(
				[
					"nombre",
				],
				(keyRequired) => {
					if (typeof data == "object" && !data[keyRequired]) {
						swal({
							text: "Asegúrate de llenar todos los campos con *.",
						});
						data = false;
					}
				}
			);
			if (!data) return false;

			// VALIDACIÓN RÁPIDA
			if (!data.id_pk && !this.args.usuarioIdPk) {
				data.id_usuario_fk = this.authGetUser.id_pk;
			} else if(!data.id_pk && this.args.usuarioIdPk){
				data.id_usuario_fk = this.args.usuarioIdPk;
			}

			data.id_ultimo_usuario_fk = this.authGetUser.id_pk;
			data.ultima_actualizacion = moment().format("YYYY-MM-DD HH:mm:ss");

			delete data.asides.recetas
			delete data.asides.selection

			return data;
		},

		// PREPARA Y ABRE EL MODAL PARA UN NUEVO ELEMENTO. 
		// (LLAMADO NORMALMENTE DESDE FUERA)
		openForNew() {
			this.form = _.cloneDeep(planArchetype);
			this.$bvModal.show(this.domID);
		},

		// FUNCIÓN DISPARADA EN CASO DE OCULTACIÓN DE MODAL
		hidden() {
			this.form = _.cloneDeep(planArchetype);
			if (this.mobi != null && typeof this.mobi.destroy == 'function') {
				this.mobi.destroy()
			}
			this.$bvModal.hide(this.domID);
		},

		// ENVIÓ DE FORMULARIO
		onSubmit($evnt) {
			$evnt.preventDefault();
			this.store();
		},

		async ask4NewItem(domIdHolder, dayIndex, mealIndex) {
			let parent = this
			this.mobi = await mobiscroll.select("#" + this.idHolder, {
				display: "bubble",
				anchor: '#' + domIdHolder,
				inputClass: "form-control form-control-sm",
				placeholder: "Busca un ingrediente",
				filter: true,
				fullData: [],
				label: "Busca el ingrediente que deseas incluír en la receta",
				data: {
					remoteFilter: true,
					url: this.computedURI,
					type: "json",
					processResponse: (response) => {
						this.fullData = [];
						if (!!response.data.rows && response.data.rows.length) {
							this.fullData = _.map(response.data.rows, (item) => {
								return {
									value: item.value,
									text: item.text,
									html: `<p>${item.text}</p>`,
									item: _.clone(item),
								};
							});
						} else {
							this.fullData = [
								{
									value: null,
									text: "Nada encontrado",
									html: "<p>Nada encontrado</p>",
									item: {},
								},
							];
						}
						return this.fullData;
					},
				},
				onSet: (a, b) => {
					let data2push = {
						"dia": dayIndex.toString(),
						"tipo": mealIndex.toString(),
						"id_receta_fk": b.getVal(),
					}
					let receta2push = _.find(this.fullData, { value: b.getVal() })
					if (_.findIndex(parent.form.asides.recetas, { id_pk: b.getVal() }) == -1)
						parent.form.asides.recetas.push(receta2push.item.receta)
					parent.form.asides.planreceta.push(data2push)
				},
				onClose: (a, b) => {
					b.clear()
				}
			});
			this.mobi.show()
		},

		// REMUVE UNA RECETA
		async tryRemovePlanReceta(dia, tipo, id_receta_fk) {
			let swalResponse = await swal({
				title: '¿Seguro que deseas eliminar esta receta del plan?',
				icon: 'info',
				buttons: {
					cancel: 'Cancelar',
					danger: 'Si, quítala'
				}
			})
			if (swalResponse == 'danger') {
				this.form.asides.planreceta.splice(_.findIndex(this.form.asides.planreceta, { dia, tipo, id_receta_fk }), 1)
			}
		},

		// PREGUNTA Y CONTINÚA CON EL BORRADO DEL REGISTRO
		async tryToDelete(itemID) {
			if (!!itemID) {
				const swalResponse = await swal({
					text: "¿Estás seguro que deseas eliminar éste registro?",
					icon: "info",
					buttons: {
						cancel: "Cancelar",
						danger: "Si, bórrala",
					},
				});
				if (swalResponse == "danger") {
					// HE SAID YES!
					this.isProcessing = true;
					const response = await axios.delete(
						this.dataSource + "/" + itemID
					);
					if (response.status) {
						this.loadUp().then(() => {
							this.$bvModal.hide(this.domID);
							this.isProcessing = false;
						});
					} else {
						this.isProcessing = false;
					}
				}
			} else {
				swal({
					text: "Para poder eliminar un registro, éste debe especifcar un ID de eliminación.",
				});
			}
		},

		async loadItem(id_pk) {
			this.isLoading = true;
			try {
				const response = await axios.get(dataSource + "/" + id_pk);
				console.log("response", response);
				// ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
				if (response.msg) {
					mobiscroll.snackbar({
						display: "top",
						theme: "ios",
						message: response.msg,
						color: response.class,
						duration: 7000,
					});
				}
				if (response.status) {
					this.originalData = _.cloneDeep(response.data.plan);
					let data4Form = _.cloneDeep(response.data.plan);
					data4Form.asides = response.data.asides;
					data4Form.asides.selection = null;
					this.form = data4Form;
				}
			} catch (e) {
				console.error(e);
				mobiscroll.snackbar({
					display: "top",
					theme: "ios",
					message: "Ocurrió un error obteniendo la respuesta: " + e,
					color: "warning",
					duration: 7000,
				});
			}
			this.isLoading = false;
			// this.form = _.cloneDeep(item)
			this.$bvModal.show(this.domID);
		},

		async refresh() {
			this.isLoading = true;
			await this.loadUp();
			this.isLoading = false;
		},

		async loadUp() {
			if (typeof this.$parent.loadUp == "function")
				await this.$parent.loadUp();
		},

		async store() {
			let data2send = this.getDataForSubmit();
			if (!!data2send) {
				this.isProcessing = true;
				const response = await axios.post(
					this.dataSource +
					(!!this.form.id_pk ? "/" + this.form.id_pk : ""),
					data2send
				);

				if (response.status) {
					await this.loadUp();
					this.hidden();
				}
				this.isProcessing = false;
			}
		}

	},

	async beforeDestroy() {
		if (typeof this.mobi == 'object') {
			await this.mobi.hide();
			await this.mobi.destroy();
		}
	},

	async beforeMount() {
		this.domID = _.uniqueId("PlanMainModel-");
		this.idHolder = _.uniqueId("idHolder-");
	}

};
</script>

<style lang="less">
#dataholder {

	.custom-switch.b-custom-control-lg .custom-control-label,
	.input-group-lg .custom-switch .custom-control-label {
		/* font-size: 1.25rem; */
		font-size: 1.05rem;
	}

}
</style>